import { render, staticRenderFns } from "./MedicinesPage.vue?vue&type=template&id=53e30c29&scoped=true"
import script from "./MedicinesPage.vue?vue&type=script&lang=js"
export * from "./MedicinesPage.vue?vue&type=script&lang=js"
import style0 from "./MedicinesPage.vue?vue&type=style&index=0&id=53e30c29&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e30c29",
  null
  
)

export default component.exports